import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import R from 'ramda';
import Picture from '@cotyorg/ccx-atoms/Picture';
import StandardLayout from '../../templates/StandardLayout';
import { Knowledge } from './Sections/Knowledge/Knowledge';
import { ProductCollection } from './Sections/ProductCollection/ProductCollection';
import { TipsAndTricksSection } from './Sections/TipsAndTricks/TipsAndTricks';
import { PledgeSection } from './Sections/Pledge/Pledge';
// import { RecyclingSection } from './Sections/Recycling/Recycling';
import { VideoSection } from './Sections/Video/Video';
import { FaqSection } from './Sections/Faq/Faq';
import { HeaderSection } from './Sections/Header/Header';
import { BenefitsSection } from './Sections/Benefits/Benefits';
import { BeforeAfterSection } from './Sections/BeforeAfter/BeforeAfter';

const KindAndFreePage = ({
  currentBreakpoint,
  sectionHeadings,
  videos,
  ctas,
  tabs,
  images,
  poster,
}) => (
  <StandardLayout>
    <div className="kind-and-free-page">
      <HeaderSection sectionHeadings={sectionHeadings} />

      {videos.mainVideo && <VideoSection videos={videos} />}

      {!videos.mainVideo && (
        <div className="poster">
          <Picture
            alt={R.prop('alt', poster)}
            src={R.prop('imageSrc', poster)}
            srcset={R.prop('imageSrcSet', poster)}
          />
        </div>
      )}

      <Knowledge sectionHeadings={sectionHeadings} />

      <BeforeAfterSection
        sectionHeadings={sectionHeadings}
        images={images}
        currentBreakpoint={currentBreakpoint}
      />

      <ProductCollection sectionHeadings={sectionHeadings} ctas={ctas} />

      <BenefitsSection sectionHeadings={sectionHeadings} />

      <TipsAndTricksSection sectionHeadings={sectionHeadings} videos={videos} />

      <PledgeSection sectionHeadings={sectionHeadings} videos={videos} />

      <FaqSection sectionHeadings={sectionHeadings} tabs={tabs} />

      {/* Temporary disabled due to lack of copy
      <RecyclingSection sectionHeadings={sectionHeadings} />
      */}
    </div>
  </StandardLayout>
);

KindAndFreePage.propTypes = {
  sectionHeadings: PropTypes.instanceOf(PropTypes.object),
  videos: PropTypes.instanceOf(PropTypes.object),
  ctas: PropTypes.objectOf(PropTypes.object),
  tabs: PropTypes.objectOf(PropTypes.object),
  images: PropTypes.objectOf(PropTypes.object),
  poster: PropTypes.objectOf(PropTypes.object),
  currentBreakpoint: PropTypes.string,
};

export default connect(({ content, breakpoints }) => ({
  sectionHeadings: R.prop('sectionHeadings', content),
  videos: R.prop('videos', content),
  ctas: R.prop('ctas', content),
  tabs: R.prop('tabs', content),
  images: R.prop('images', content),
  poster: R.prop('poster', content),
  currentBreakpoint: R.prop('current', breakpoints),
}))(KindAndFreePage);
